<template>
  <div class="col-xxl-9 col-xl-12 col-lg-12 col-md-12col-12">
    <div class="card">
      <div class="card-header">
        <div class="transaction-value">Transactions value by month</div>
      </div>
      <div class="card-body">
        <div class="chart-container column-container">
          <apexchart
            v-if="chartSeries.length && chartSeries[0].data && chartSeries[0].data.length"
            height="400"
            type="bar"
            :options="chartOptions"
            :series="chartSeries"
          ></apexchart>
          <p v-else>Loading data or no data available...</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useReportStore } from '@/store/driver/report';

// 使用Pinia狀態管理
const { reportInfo } = useReportStore();

// 計算每日面值
const dailyFaceValue = computed(() => reportInfo.daily_face_value || {});

// 格式化日期標籤
const formatDateLabels = (dates, interval) => {
  return dates.map((date, index) => {
    const [year, month, day] = date.split('-');
    const prevMonth = index > 0 ? dates[index - 1].split('-')[1] : month;

    if (index % interval === 0) {
      return (day === '01' || day === '31') && (index === 0 || prevMonth !== month) ? `${month}/${day}` : day;
    }
    return ''; // 保留空格佔位
  });
};

// 動態設置x軸類別
const xAxisCategories = computed(() => {
  const dates = Object.keys(dailyFaceValue.value);
  const length = dates.length;

  if (length === 0) return []; // 如果數據為空，返回空數組以避免錯誤

  if (length <= 7) {
    return formatDateLabels(dates, 1); // 每天顯示
  } else if (length > 7 && length <= 15) {
    return formatDateLabels(dates, 2); // 每兩天顯示
  } else if (length > 15 && length <= 31) {
    return formatDateLabels(dates, 2); // 每四天顯示
  } else {
    return formatDateLabels(dates, 4); // 默認每四天顯示
  }
});

// 準備圖表數據系列
const chartSeries = computed(() => {
  const data = Object.values(dailyFaceValue.value);
  return data.length ? [{ data }] : []; // 確保返回有效的數據結構
});

// 圖表選項
const chartOptions = computed(() => ({
  chart: {
    height: 350,
    type: 'bar',
    toolbar: {
      show: false,
    },
    zoom: {
      enabled: false,
    },
  },
  legend: {
    show: false,
  },
  colors: ['#00C962'],
  dataLabels: {
    enabled: false,
  },
  plotOptions: {
    bar: {
      borderRadius: 0,
      horizontal: false,
      columnWidth: '70%', // 調整柱形的寬度以減少間距
      endingShape: 'flat'
    },
  },
  stroke: {
    show: true,
    width: 2,
    colors: ['transparent'],
  },
  xaxis: {
    categories: xAxisCategories.value,
    labels: {
      style: {
        fontSize: '12px',
      },
    },
    tickPlacement: 'between',
    title: {
      text: '',
      style: {
        fontSize: '14px',
        color: '#333',
      }
    }
  },
  yaxis: {
    tickAmount: 7,
    max: Math.max(...chartSeries.value[0]?.data, 700), // 自動計算最大值
    min: 0,
    labels: {
      style: {
        fontSize: '14px',
        color: '#333',
      },
      formatter: function (val) {
        return '$' + val.toFixed(0);
      },
    },
  },
  grid: {
    borderColor: '#e0e0e0',
    strokeDashArray: 5,
  },
  fill: {
    colors: ['#00C962'],
  },
  tooltip: {
    y: {
      formatter(val) {
        return '$ ' + val.toFixed(2);
      },
    },
    custom: function({ series, seriesIndex, dataPointIndex, w }) {
      const value = series[seriesIndex][dataPointIndex];
      return `<div class="arrow_box p-2" style="background-color: white; border: 1px solid #ddd; border-radius: 5px;">
                  <span>$${value.toFixed(2)}</span>
              </div>`;
    }
  },
}));
</script>

<style scoped>
.card{
 min-height: 627px;
}


.chart-container {
  padding: 20px;
}

.transaction-value{
  font-family: Euclid Square;
  font-size: 24px;
  font-weight: 500;
  line-height: 30.43px;
  text-align: left;
  margin-bottom: 20px;
}

.arrow_box {
  position: relative;
  background: #fff;
  border: 1px solid #ddd;
}

.arrow_box::after, .arrow_box::before {
  bottom: 100%;
  left: 50%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.arrow_box::after {
  border-color: rgba(255, 255, 255, 0);
  border-bottom-color: #fff;
  border-width: 10px;
  margin-left: -10px;
}

.arrow_box::before {
  border-color: rgba(221, 221, 221, 0);
  border-bottom-color: #ddd;
  border-width: 11px;
  margin-left: -11px;
}
</style>
